import './App.css';
import FirstScreenRec from './SecondReceptionistScreens/FirstScreenRec';
import SecondScreenRec from './SecondReceptionistScreens/SecondScreenRec';
import ThirdScreenRec from './SecondReceptionistScreens/ThirdScreenRec';
import FourthScreenRec from './SecondReceptionistScreens/FourthScreenRec';
import FifthScreenRec from './SecondReceptionistScreens/FifthScreenRec';
import SixthScreenRec from './SecondReceptionistScreens/SixthScreenRec';
import SeventhScreenRec from './SecondReceptionistScreens/SeventhScreenRec';
import EighthScreenRec from './SecondReceptionistScreens/EighthScreenRec';
import NinthScreenRec from './SecondReceptionistScreens/NinthScreenRec';
import TenthScreenRec from './SecondReceptionistScreens/TenthScreenRec';
import EleventhScreenRec from './SecondReceptionistScreens/EleventhScreenRec';
import ByMe from './components/ByMe/ByMe';
import FloatingWhatsAppButton from './components/FloatingButton/FloatingButton';
import PrivacyPolicy from './SecondReceptionistComponents/privacy/privacy';

const ReceptionistWrapper=()=> {
  return <>
  <FirstScreenRec/>
  <SecondScreenRec/>
  <ThirdScreenRec/>
  <FourthScreenRec/>
  <SixthScreenRec/>
  <SeventhScreenRec/>
  <EighthScreenRec/>
  <NinthScreenRec/>
  <TenthScreenRec/>
  <EleventhScreenRec/>
  <FifthScreenRec/>
  {/* <ReceptionistHeroSection/>
  <ReceptionistSignals/>
  <ReceptionistSPassion/>
   <ReceptionistAboutMe/>
  <Receptionistbonus/>
  <ReceptionistCourseBenefits/>
  <ReceptionistCourseUpsAndDowns/>
  <ReceptionistCourseWhyNow/>
  <ReceptionistCourseTwoOptions/>
<ReceptionistFAQSection/> */}
 
<FloatingWhatsAppButton/>
    <PrivacyPolicy 
                      ownerName="קרן אקסלרוד - המשרד" 
                      email="Kerenaxelrod@gmail.com" 
                      phone="+972 50-891-9747" 
                      domain="https://hamisrad.co.il/" 
                    />
{/* <ExitIntentPopup/> */}
<ByMe/>
  </>
}

export default ReceptionistWrapper;
